import styled from 'styled-components'
import { useTranslation } from "react-i18next"
import { Checkbox, Form } from 'antd'
import { WpEnvCityEnum } from '../enums'

interface SelectCourseTermsProps {
  isRequestingCreateOrder: boolean
  onClickBack: () => void
  onClickNext: () => void
  wpEnvCity: keyof typeof WpEnvCityEnum | ''
}

const SelectCourseTerms = ({ isRequestingCreateOrder, onClickBack, onClickNext, wpEnvCity }: SelectCourseTermsProps) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const onFinish = (values: any) => {
    onClickNext()
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }
  return (
    <Wrapper id="step-terms-and-agreements">
      {
        wpEnvCity === 'vn' ? 
          t('notice_accept_one_time_changes_booking')
        : 
          t('notice_changes_reservation_are_not_permitted')
      }
      <br /><br />
      {t('notice_arrive_more_than_15_mins')}
      <br /><br />
      {t('notice_kindly_tell_us_allergy')}
      <br /><br />
      <Form
        form={form}
        className="yz-form"
        autoComplete="off"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <div className="yz-input-wrapper">
          <Form.Item
            name="terms"
            valuePropName="checked"
            rules={[{ required: true, message: t('notice_accept_terms_and_agreements') }]}
          >
            <Checkbox>{t('have_read_terms_agressments')}</Checkbox>
          </Form.Item>
        </div>

        <Footer>
          <div className="yuzu-btn -outline -lg" onClick={onClickBack}><span>{t('back')}</span></div>
          <div className="yuzu-btn -lg" onClick={() => form.submit()}>
            {
              isRequestingCreateOrder? (
                <svg
                  width="30px"
                  height="30px"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid"
                  className="lds-rolling"
                >
                  <circle cx="50" cy="50" fill="none" ng-attr-stroke="{{config.color}}" ng-attr-stroke-width="{{config.width}}" ng-attr-r="{{config.radius}}" ng-attr-stroke-dasharray="{{config.dasharray}}" stroke="#fff" strokeWidth="10" r="35" strokeDasharray="164.93361431346415 56.97787143782138" transform="rotate(162 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="400ms" begin="0s" repeatCount="indefinite"></animateTransform></circle>
                </svg>
              ): (
                  <span>{t('next')}</span>
              )
            }
          </div>
        </Footer>
      </Form>
    </Wrapper>
  )
}

export default SelectCourseTerms

const Wrapper = styled.div`
  max-width: 500px;
  text-align: center;

  .ant-checkbox-wrapper {
    justify-content: center;
  }
`

const Footer = styled.div`
  margin-top: 64px;
  margin-bottom: 80px;
  display: flex;
  justify-content: space-between;
`